/*eslint-disable*/
import api from '../'

class chainsGameItems {
    // POST: revived-numbers
    static getRevivedNumbersByRequest () {
        return api.axios.get('/revivedNumbersByRequest').then(response => response.data);
    }
}

export default chainsGameItems;
